import SectionHub from '@/components/docs/SectionHub';

export default function Docs01MarketDataHub() {
  return <SectionHub sectionPath="01-market-data" />;
}
